import React, { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  viewTenantApi,
  tenantDeleteApi,
  tenantStatusApi,
} from "../../../api/Api";
import { useCookies } from "react-cookie";
import RouteConstants from "../../../constants/routeConstants.json";

export const TenantDetailsContext = createContext({});
export const TenantDetailsContextProvider = ({ children }) => {
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [tenantData, setTenantData] = useState([]);
  const [tenantName, setTenantName] = useState("");
  const [tenantEmail, setTenantEmail] = useState("");
  const [tenantPhone, setTenantPhone] = useState();
  const [tenantOrgName, setTenantOrgName] = useState("");
  const [tenantOrgEmail, setTenantOrgEmail] = useState("");
  const [tenantOrgType, setTenantOrgType] = useState("");
  const [tenantLocation, setTenantLocation] = useState("");
  const [tenantStatus, setTenantStatus] = useState("");
  const [subscriptionPlan, setSubscriptionPlan] = useState("");

  const [errorPopup, setErrorPopup] = useState(false);
  const [statusError, setStatusError] = useState(false);
  const [deleteError, setDeleteError] = useState(false);

  const [deleteAlertPopup, setDeleteAlertPopup] = useState(false);
  const [deactivateAlertPopup, setDeactivateAlertPopup] = useState(false);
  const [statusSuccessPopup, setStatusSuccessPopup] = useState(false);
  const [deleteSuccessPopup, setDeleteSuccessPopup] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [popupButtonText, setPopupButtonText] = useState("");
  const [neededStatus, setNeededStatus] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [statusValue, setStatusValue] = useState();
  const [buttonText, setButtonText] = useState("");

  const [errorAlertMessage, setErrorAlertMessage] = useState("");

  useEffect(() => {
    viewTenantDetails(adminId);
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const adminId = location?.state?.id;
  // console.log("tenantOrgName", tenantOrgName);

  const goToLogin = () => {
    removeCookie("x-access-token");
    navigate(RouteConstants.LOGIN);
  };

  // Tenant Permissions
  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "67371df9534964294f80cfe4";
  })[0];

  const goToTenantEditPage = (id) => {
    navigate(RouteConstants.EDIT_TENANT, { state: { id } });
  };

  const goToTenantListPage = () => {
    navigate(RouteConstants.TENANT_LIST);
  };

  const viewTenantDetails = async (adminId) => {
    try {
      setErrorPopup(false);

      setSpinnerStatus(true);
      const tenantInfo = await viewTenantApi(adminId);

      if (tenantInfo?.status === 200) {
        setSpinnerStatus(false);
        // setTenantData(tenantData?.data?.data?.tenant);
        setTenantName(tenantInfo?.data?.data?.tenant?.name);
        setTenantEmail(tenantInfo?.data?.data?.tenant?.email);
        setTenantPhone(tenantInfo?.data?.data?.tenant?.phone);
        setTenantOrgName(tenantInfo?.data?.data?.tenant?.organizationName);
        setTenantOrgEmail(tenantInfo?.data?.data?.tenant?.organizationEmail);
        setTenantOrgType(tenantInfo?.data?.data?.tenant?.organizationType);
        setTenantStatus(tenantInfo?.data?.data?.tenant?.status);
        setTenantLocation(tenantInfo?.data?.data?.tenant?.location);
        const subscriptionPlanData =
          tenantInfo?.data?.data?.tenant?.subscriptionPlan;
        if (subscriptionPlanData) {
          const formatedData = `${subscriptionPlanData.name} (${subscriptionPlanData.billingCycle})`;
          setSubscriptionPlan(formatedData);
        }
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";

      setStatusValue(responseStatus);
      setErrorAlertMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
    }
    setSpinnerStatus(false);
  };

  const handleTenantDelete = async () => {
    try {
      setSpinnerStatus(true);
      const tenantDeleteDetails = await tenantDeleteApi(adminId);
      if (tenantDeleteDetails.status === 200) {
        setDeleteAlertPopup(false);
        setDeleteSuccessPopup(true);
        setErrorAlertMessage(tenantDeleteDetails.data.message);
      }
      console.log("tenantDeleteDetails", tenantDeleteDetails);
    } catch (error) {
      setDeleteAlertPopup(false);

      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";

      setStatusValue(responseStatus);
      setErrorAlertMessage(errorMessage);
      setDeleteError(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }

      setSpinnerStatus(false);
    }
    setSpinnerStatus(false);
  };

  const handleTenantStatus = async (adminId, status) => {
    try {
      const activateResponse = await tenantStatusApi(adminId, status);
      console.log("activateResponse", activateResponse);
      console.log("activateResponse", activateResponse.data.message);
      console.log("activateResponse", activateResponse.status);
      if (activateResponse.status === 200) {
        setStatusSuccessPopup(true);
        setErrorAlertMessage(activateResponse.data.message);
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";

      setStatusValue(responseStatus);
      setStatusError(true);
      setErrorAlertMessage(errorMessage);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }

      setSpinnerStatus(false);
    }
  };

  const providerValue = {
    adminId,
    tenantName,
    tenantEmail,
    tenantPhone,
    tenantOrgName,
    tenantOrgEmail,
    tenantOrgType,
    tenantStatus,
    tenantLocation,
    errorPopup,
    setErrorPopup,
    errorAlertMessage,
    subscriptionPlan,
    spinnerStatus,
    deactivateAlertPopup,
    setDeactivateAlertPopup,
    deleteAlertPopup,
    setDeleteAlertPopup,
    goToTenantEditPage,
    handleTenantDelete,
    deleteSuccessPopup,
    setDeleteSuccessPopup,
    goToTenantListPage,
    statusMessage,
    setStatusMessage,
    popupButtonText,
    setPopupButtonText,
    handleTenantStatus,
    neededStatus,
    setNeededStatus,
    viewTenantDetails,
    statusSuccessPopup,
    setStatusSuccessPopup,
    statusError,
    setStatusError,
    deleteError,
    setDeleteError,
    permissionAccess,

    statusValue,
    buttonText,
    goToLogin,
  };
  return (
    <TenantDetailsContext.Provider value={providerValue}>
      {children}
    </TenantDetailsContext.Provider>
  );
};
